export const DIRECTION_IN = 'IN' // Receptiva
export const DIRECTION_OUT = 'OUT' // Ativa
export const DIRECTION_AUTO = 'AUTO' // Automática
